module.exports = __webpack_public_path__ + "b846c21df6c761a81f1706885209e2f6.svg";